import { observer } from 'mobx-react';
import React from 'react';
import logo from '../../assets/images/logo.png';
import { SmartCaptcha } from '@yandex/smart-captcha';
import AuthStore from '../../store/auth/AuthStore';

const LoginForm: React.FC = observer(() => {
  return (
    <div
      className='sr__authForm'
    >
      <img
        className='sr__authForm__logo'
        src={logo}
        alt='ScoReflect logotype'
      />
      <h1 className='sr__authForm__title'>Введите номер</h1>
      <h4 className='sr__authForm__description'>Ваш номер телефона будет использоваться для входа в аккаунт</h4>
      <div className='sr__authForm__input'>
        <input
          className='sr__authForm__textField'
          inputMode='tel'
          name='phoneNumber'
          autoComplete='phoneNumber'
          placeholder='+7 000 000 00 00'
          type='tel'
          defaultValue={AuthStore.phoneNumber}
          onChange={AuthStore.onChangePhoneNumber}
        />
        <div className='sr__authForm__input--error' id='phone_number_error'>Некорректный номер телефона</div>
      </div>
      <button
        className='sr__authForm__button'
        disabled={!AuthStore.validate()}
        onClick={AuthStore.onClickContinue}
      >Войти через Telegram</button>
      {/* <div className='sr__authForm__input'>
        <SmartCaptcha
          key={AuthStore.captchaKey}
          sitekey='ysc1_FqfJKS5ZjzZa8DScrJQaR56sJdzJJ45zRQ0DynAE0eefd35c'
          language='ru'
          onSuccess={AuthStore.onSuccessCaptcha}
        />
        <div className='sr__authForm__input--error' id='captcha_error'>Капча не пройдена</div>
      </div> */}
      <p className='sr__authForm__agreement'>Нажимая «Продолжить», Вы принимаете <a href='/' target='_blank'>пользовательское соглашение</a> и <a href='/' target='_blank'>политику конфиденциальности</a></p>
    </div>
  );
});

export default LoginForm;